<!-- src/App.vue -->
<template>
  <Particles />
  <Hero />
  <Benefits />
  <Network />
  <PlanSingle />
  <Faq />

</template>

<script setup>
import Hero from "../components/Hero";
import Benefits from "../components/Benefits";
import Network from "../components/Network";
import PlanSingle from "../components/PlanSingle";
import Faq from "../components/Faq";
import Particles from "../components/Particles"

import { useHead } from '@vueuse/head'

useHead({
  title: 'Grapefroot | Joocy SIMs with Joocy benefits',
  meta: [
    {
      name: 'description',
      content: 'Meta description',
    },
  ],
})


</script>
